(function (window) {

    var timeout = 5000;

    function back2Index() {
        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.indexUrl);
    }

    /**
     * 访问管理中心前分发跳转
     * @param userInfo
     * @param callback
     * @param flag 是否管理中心调用
     */
    function validateAfterLogin(userInfo, callback, func, mainUserID, acceptInvitation, flag) {
        var urlBeforeLogin = AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin");
        var isResellerFlag = (urlBeforeLogin && urlBeforeLogin.indexOf('reseller') > -1) ? '?reseller=2' : '';
        var urlHref = window.location.href;
        var htmlName = getHtmlName(window.location.href);
        var isharmonyUrl = (urlHref.indexOf('?type=1&channel=8') > -1 || urlHref.indexOf('harmonyCenter') > -1);
        if (AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin") &&
            (AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin").indexOf('channel=8') > 0 ||
                AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin").indexOf('harmonyCenter') > 0) && urlHref.indexOf('handleLoginMemberCenter') > -1) {
            isharmonyUrl = true;
        }
        if ((mainUserID || acceptInvitation) && (callback) && (typeof callback == 'function')) {
            callback();
            return;
        }
        if (!userInfo || !userInfo.id) {
            // 无用户信息，返回首页
            back2Index();
            return;
        }
        if (!userInfo.verifyRealState) {
            if (userInfo.userType) {
                var isMngRenZheng = userInfo && userInfo.attributes2 && JSON.parse(userInfo.attributes2).isMngRenZheng == 'Y';
                if (userInfo.userType == 1) {
                    if ((userInfo.isMngRenZheng || isMngRenZheng) && func == false) {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.sensitiveAppUrl + "?t=1");
                    } else if (htmlName != getHtmlName(sysUrlCfg.user.userDeveloperUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.userAuthPerUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.userCardrzUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.userPerfectUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.sensitiveAppUrl)) {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperUrl);
                    } else {
                        if ((callback) && (typeof callback == 'function')) {
                            callback();
                        }
                    }
                } else {
                    if ((userInfo.isMngRenZheng || isMngRenZheng) && func == false) {
                        if (isharmonyUrl) {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperCorpUrl + "?type=1&channel=8");
                        } else {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.sensitiveAppUrl + "?t=2");
                        }
                    } else if (userInfo.leftPayVerifyQuantity > 0 && htmlName != getHtmlName(sysUrlCfg.user.userDeveloperCorpUrl) && htmlName != getHtmlName(sysUrlCfg.user.sensitiveAppUrl)) {
                        if (isharmonyUrl) {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperCorpUrl + "?type=1&channel=8");
                        } else {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperCorpUrl);
                        }
                    } else if (userInfo.leftPayVerifyQuantity <= 0 && htmlName != getHtmlName(sysUrlCfg.user.userAuthCorpUrl)) {
                        if (isharmonyUrl) {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthCorpUrl + "?type=1&channel=8");
                        } else {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthCorpUrl);
                        }
                    } else {
                        if ((callback) && (typeof callback == 'function')) {
                            callback();
                        }
                    }
                }
            } else {
                // 未实名认证用户返回首页实名认证
                if (AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin") &&
                    AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin").indexOf('channel=8') > 0) {
                    htmlName = getHtmlName(AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin"));
                }
                if ((htmlName != getHtmlName(sysUrlCfg.user.userAuthSelUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userAuthPerUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userAuthCorpUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userDeveloperUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userCardrzUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userPerfectUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userDeveloperCorpUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.userCorpatteionrzUrl))
                    && (htmlName != getHtmlName(sysUrlCfg.user.sensitiveAppUrl))) {
                    if (isharmonyUrl) {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperCorpUrl + "?type=1&channel=8");
                    } else {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthSelUrl + isResellerFlag);
                    }
                } else {
                    if ((callback) && (typeof callback == 'function')) {
                        callback();
                    }
                }
            }
        } else if (userInfo.verifyRealState == 3) {
            if (userInfo.userType) {
                if (userInfo.userType == 1) {
                    if (htmlName != getHtmlName(sysUrlCfg.user.userDeveloperUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.userAuthPerUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.userCardrzUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.userPerfectUrl)
                        && htmlName != getHtmlName(sysUrlCfg.user.sensitiveAppUrl)) {

                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.sensitiveAppUrl + "?t=1");
                    } else {
                        if ((callback) && (typeof callback == 'function')) {
                            callback();
                        }
                    }
                } else {
                    if (userInfo.verifyRealType == 1 && htmlName != getHtmlName(sysUrlCfg.user.userAuthCorpUrl)) //简化实名用户
                    {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthCorpUrlSimp);
                    }//正常实名企业用户
                    else if (userInfo.verifyRealType == 0 || userInfo.verifyRealType == 4) {
                        if (userInfo.leftPayVerifyQuantity > 0 && htmlName != getHtmlName(sysUrlCfg.user.userDeveloperCorpUrl) && htmlName != getHtmlName(sysUrlCfg.user.sensitiveAppUrl)) {
                            if (isharmonyUrl) {
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperCorpUrl + "?type=1&channel=8");
                            } else {
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.sensitiveAppUrl + "?t=2");
                            }
                        } else if (htmlName != getHtmlName(sysUrlCfg.user.userAuthCorpUrl) && userInfo.leftPayVerifyQuantity <= 0) {
                            if (isharmonyUrl) {
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthCorpUrl + "?type=1&channel=8");
                            } else {
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthCorpUrl);
                            }
                        } else {
                            if (callback && (typeof callback == 'function')) {
                                callback();
                            }
                        }
                    } else {
                        if ((callback) && (typeof callback == 'function')) {
                            callback();
                        }
                    }
                }
            } else {
                if (isharmonyUrl) {
                    AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userDeveloperCorpUrl + "?type=1&channel=8");
                } else {
                    // 未实名认证用户返回实名认证页面
                    AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.userAuthSelUrl + isResellerFlag);
                }
            }
        } else {
            if (flag && (callback) && (typeof callback == 'function')) {
                callback();
            } else if ((htmlName == getHtmlName(sysUrlCfg.user.userAuthSelUrl))
                || (htmlName == getHtmlName(sysUrlCfg.user.userAuthPerUrl))
                || (htmlName == getHtmlName(sysUrlCfg.user.userAuthSubmitUrl))
                || (htmlName == getHtmlName(sysUrlCfg.user.userDeveloperUrl))
                || (htmlName == getHtmlName(sysUrlCfg.user.userCardrzUrl))
                || (htmlName == getHtmlName(sysUrlCfg.user.userPerfectUrl))) {


                //如果是资料的修改待审核状态
                if (htmlName === getHtmlName(sysUrlCfg.user.userAuthSubmitUrl) && userInfo.verifyRealState === 1) {
                    var updateInfoJson = {};
                    if (userInfo.updateInfo && typeof userInfo.updateInfo == 'string') {
                        updateInfoJson = JSON.parse(userInfo.updateInfo);
                    }

                    //如果是个人转企业的用户，则直接跳到修改资料页面
                    if (userInfo.userType === 1 && updateInfoJson && updateInfoJson.corpDeveloper) {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.memberCenterUrl + "#/mysetting");
                    } else {
                        AUI.BaseJSUtil.redirectUrl(sysParamCfg.user.indexUrl);
                    }
                } else {
                    AUI.BaseJSUtil.redirectUrl(sysParamCfg.user.indexUrl);
                }
            }
            // 企业用户不能再进入企业认证页面
            else if ((htmlName == getHtmlName(sysUrlCfg.user.userAuthCorpUrl))
                && (userInfo.userType == 2)) {
                AUI.BaseJSUtil.redirectUrl(sysParamCfg.user.indexUrl);
            } else {
                // 走应用认领的逻辑
                queryClaimsInfo(userInfo, callback, func);
            }
        }
    }

    //如果是带实名认证的参数说明是社区走实名认证进来的，那么直接到实名认证，去掉mainUserID
    function getUserInfo(callback, isEnrollment, res) {
        if (isEnrollment == 'true') {
            AUI.HDGWCall.delUserInfoKey("teamid");
            handleUserRouteInfo(callback, isEnrollment, res);
        } else {
            handleUserRouteInfo(callback, isEnrollment, res);
        }
    }

    function handleUserRouteInfo(callback, isEnrollment, res) {
        AUI.HDGWCall.callGW('OpenUP.Server4User.getUserRouteInfo', {req: {}}).done(function (dataRoute) {
            if ((dataRoute && dataRoute.userRouteInfoList && dataRoute.userRouteInfoList.length > 0) || AUI.HDGWCall.getUserInfoValue('teamid') || !dataRoute || !dataRoute.userRouteInfoList || dataRoute.userRouteInfoList.length == 0) {
                if (dataRoute && dataRoute.userRouteInfoList && dataRoute.userRouteInfoList.length > 0 && isEnrollment != 'true') {
                    handleTeamPage(dataRoute, callback)
                    //说明是实名认证的 有团队的情况  国内的站点走到国内来 海外的站点去海外的hangdleLogin
                } else if (isEnrollment == 'true') {
                    if (AUI.HDGWCall.getCookieOrSessionSt("siteid-member") && AUI.HDGWCall.getCookieOrSessionSt("siteid-member") == sysUrlCfg.siteIDToZoneID['1'].siteID) {
                        //设置国内站点
                        AUI.HDGWCall.setUserInfoValue("siteid", sysUrlCfg.siteIDToZoneID['1'].siteID);
                        //去掉团队帐号的标识 为获取当前的用户服务
                        AUI.HDGWCall.setUserInfoValue("teamid", "");
                        sessionStorage.setItem("x-teamId", "");
                        handleGetUserInfo(callback, dataRoute);
                    } else if (!AUI.HDGWCall.getCookieOrSessionSt("siteid-member") && AUI.HDGWCall.getZoneId() == sysUrlCfg.siteIDToZoneID['1'].siteID) {
                        //去掉团队帐号的标识  为获取当前的用户服务
                        AUI.HDGWCall.setUserInfoValue("teamid", "");
                        sessionStorage.setItem("x-teamId", "");
                        handleGetUserInfo(callback, dataRoute);
                    } else if (AUI.HDGWCall.getCookieOrSessionSt("siteid-member")) {
                        //设置海外站点
                        AUI.HDGWCall.setUserInfoValue("siteid", AUI.HDGWCall.getCookieOrSessionSt("siteid-member"));
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getCookieOrSessionSt("siteid-member")].verifiedUrl);
                    } else if (!AUI.HDGWCall.getCookieOrSessionSt("siteid-member") && AUI.HDGWCall.getZoneId() != sysUrlCfg.siteIDToZoneID['1'].siteID) {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getZoneId()].verifiedUrl);
                    }
                } else {
                    handleGetUserInfo(callback, dataRoute);
                }
            } else {
                back2Index();
            }
        }).catch(function () {
            back2Index();
        });
    }

    function handleTeamPage(dataRoute, callback) {
        var userRouteInfo = dataRoute.userRouteInfoList[0];
        //考虑是服务商的情况  如果是availableUserRoute存在且availableUserRoute.length>0 取第1个 如果是服务商跳转到服务商的界面,直接到他的管理中心去
        var isResellerRole = checkIsResellerRole(userRouteInfo);
        if (isResellerRole) {
            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.resellerConsole);
            return;
        }
        //只有当不是所属的站点和默认登录的站点不一致的时候切换siteid
        if (userRouteInfo && sysUrlCfg.siteIDToZoneID[(userRouteInfo.innerSiteID || userRouteInfo.siteID)].siteID != AUI.HDGWCall.getZoneId()) {
            if (!AUI.HDGWCall.getCookieOrSessionSt("siteid-member") && userRouteInfo.memberUserID) window.sessionStorage.setItem("siteid-member", AUI.HDGWCall.getZoneId());
            AUI.HDGWCall.setUserInfoValue("siteid", sysUrlCfg.siteIDToZoneID[(userRouteInfo.innerSiteID || userRouteInfo.siteID)].siteID);
        }

        if (!userRouteInfo.memberUserID || (userRouteInfo.memberUserID && (userRouteInfo.userID == AUI.HDGWCall.getUserInfoValue('teamid')))) {
            //设置团队帐号相关的cookie
            AUI.HDGWCall.setCookieForTeamOrUser(userRouteInfo);
            sessionStorage.setItem("x-uid", userRouteInfo.userID);
            if ((userRouteInfo.innerSiteID && userRouteInfo.innerSiteID != 1) || (!userRouteInfo.innerSiteID && userRouteInfo.siteID != 1)) {
                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.siteIDToZoneID[(userRouteInfo.innerSiteID || userRouteInfo.siteID)].consoleUrl);
                return;
            }
            //说明是帐号切换
            handleGetUserInfo(callback, dataRoute);
        } else {
            if (userRouteInfo.userID && userRouteInfo.memberUserID) {
                AUI.HDGWCall.setUserInfoValue("teamid", userRouteInfo.userID);
                sessionStorage.setItem("x-teamId", userRouteInfo.userID);
                if (userRouteInfo.userType) {
                    sessionStorage.setItem("x-userType", userRouteInfo.userType);
                    AUI.HDGWCall.setCookie("x-userType", userRouteInfo.userType);
                }
                //设置灰度标识
                isGreyDeveloper(function (greyFlag) {
                    if (greyFlag) {
                        AUI.HDGWCall.setXHdGreyCookie(greyFlag);
                    } else {
                        AUI.HDGWCall.setXHdGreyCookie(0);
                    }
                    AUI.BaseJSUtil.redirectUrl(sysUrlCfg.siteIDToZoneID[(userRouteInfo.innerSiteID || userRouteInfo.siteID)].consoleUrl);
                });
            }
        }
    }

    function handleGetUserInfo(callback, dataRoute) {
        var zoneId = AUI.HDGWCall.getZoneId();
        if (AUI.BaseJSUtil.contains(['2', '3', '12', '13', '8', '15'], zoneId + '')) {
            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.abroadPortlUrl);
            return;
        }
        var req = {};
        if (AUI.HDGWCall.getUserInfoValue('teamid')) {
            req.userID = AUI.HDGWCall.getUserInfoValue('teamid');
        }
        ajaxWithErrorHDGWCall.callGWOld("OpenUP.Server4User.getDeveloperBaseInfo", {
            param: {
                req: req
            },
            callback: function (data) {
                if (data && data.NSP_STATUS && sysUrlCfg.developerStatus[data.NSP_STATUS + '']) // 当前开发者的会员资格被停用 added
                {
                    // 跳到提醒会员资格已经被停用的页面
                    AUI.BaseJSUtil.redirectUrl(location.protocol + "//" + location.host +
                        "/consumer/cn/consolePortal/pagesubspend?developerStatus=" + data.NSP_STATUS);
                    return;
                } else if (data && data.NSP_STATUS) {
                    back2Index();
                    return;
                }
                var userInfo = data.developerInfo || {};
                userInfo.id = data.userID;
                if ((callback) && (typeof callback == 'function')) {
                    callback(userInfo);
                }
            },
            onError: function (e) {
                back2Index();
            }
        }, null, timeout);
    }

    // 从url地址中获取网页文件名
    function getHtmlName(url) {
        var arr = url.split("/");
        var length = arr.length;

        var url1 = arr[length - 1];
        var arr1 = url1.split("#");

        var url2 = arr1[0];
        var arr2 = url2.split("?");

        return arr2[0];
    }

    /**
     * 查询简化应用认领消息
     */
    function queryClaimsInfo(userObj, callback, func) {
        var json = window.sessionStorage.getItem("appClaimsMsg");
        //以下只是正对实名通过的企业用户
        var htmlName = getHtmlName(window.location.href);
        //将查询的消息存储
        window.sessionStorage.removeItem("fstClaimedAppStatus");
        ajaxWithErrorHDGWCall.callGWOld("OpenCommon.Server4User.hasAppClaims", {
            param: {
                req: {}
            },
            callback: function (data) {
                if (data && data.NSP_STATUS) {
                    back2Index();
                    return;
                }
                var auditAppCnt = 0;//状态为0审核中个数的个数
                var haveClaimedCnt = 0;//状态为1认领成功的个数
                var processdAppCnt = 0;//状态为3校验中的个数

                var applyClaimsList = data.applyClaims;
                for (var i in applyClaimsList) //数组appId,packageName,appName,auditStatus
                {
                    switch (applyClaimsList[i].auditStatus) {
                        case 0:
                            auditAppCnt++;
                            break;
                        case 1:
                            haveClaimedCnt++;
                            break;
                        case 3:
                            processdAppCnt++;
                            break;
                        default:
                            break;
                    }
                }

                //结合用户实名认证状态进项判断
                var isSimplUser = userObj.userType == 2 && userObj.verifyRealType == 1;
                var hasNoApp = auditAppCnt + haveClaimedCnt + processdAppCnt == 0;
                //申请第一款应用在审核
                var hasAuditApp = auditAppCnt > 0 && haveClaimedCnt == 0;
                //申请第一款应用在处理
                var hasProcessApp = processdAppCnt > 0 && haveClaimedCnt == 0;
                if (isSimplUser && hasNoApp)//跳转认领页面
                {
                    if (htmlName != getHtmlName(sysUrlCfg.user.appClaimPage)) {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.appClaimPage);
                    }
                } else if (isSimplUser && (hasAuditApp || hasProcessApp)) //跳转提示页面，提示正在处理，请等待，按钮转到首页
                {
                    ajaxWithErrorHDGWCall.callGWOld("OpenCommon.Server4User.getClaimsState", {
                        param: {
                            req: {}
                        },
                        callback: function (data) {

                            if (data.retCode == 0 && data.retCount > 0)//转到显示页面
                            {
                                var claimsInfosList = [];
                                data.claimsInfos.forEach(function (claim) {
                                    if (claim.auditStatus == 0 || claim.auditStatus == 3) {
                                        claimsInfosList.push(claim);
                                    }
                                })
                                window.sessionStorage.setItem("fstClaimedAppStatus", JSON.stringify(claimsInfosList));
                                //下一步的跳转页面地址
                                //查询后台接口OpenOther.Developer.getAppClaimsMessages
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.memberCenterIndication);
                            }
                            if (data && data.NSP_STATUS) {
                                back2Index();
                                return;
                            }
                        },
                        onError: function () {
                            back2Index();
                        }
                    }, null, timeout);
                } else { //简化用户有app,或正常用户，显示消息，按钮为“管理中心”和“首页”
                    if (!func) {
                        if (json && null != json) {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.memberCenterIndication);
                            return;
                        } else {
                            ajaxWithErrorHDGWCall.callGWOld("OpenCommon.Server4User.getClaimsState", {
                                param: {
                                    req: {}
                                },
                                callback: function (data) {
                                    if (data && data.NSP_STATUS) {
                                        back2Index();
                                        return;
                                    }
                                    if (data.retCode == 0 && data.retCount > 0)//转到显示页面
                                    {
                                        window.sessionStorage.setItem("appClaimsMsg", JSON.stringify(data.claimsInfos));
                                        //下一步的跳转页面地址
                                        //查询后台接口OpenOther.Developer.getAppClaimsMessages
                                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.memberCenterIndication);
                                    } else if (data.retCode == 0 && data.retCount == 0) //没有通知信息直接进管理中心
                                    {
                                        // 用户鉴权全部通过，执行回调函数
                                        if ((callback) && (typeof callback == 'function')) {
                                            callback();
                                        }
                                    }
                                },
                                onError: function () {
                                    back2Index();
                                }
                            }, null, timeout);
                        }
                    } else {
                        if ((callback) && (typeof callback == 'function')) {
                            callback();
                        }
                    }

                }
            },
            onError: function () {
                back2Index();
            }
        }, null, timeout);
    }

    function isGreyDeveloper(callback) {
        ajaxWithErrorHDGWCall.callGWOld("OpenUP.Server4User.isGreyDeveloper", {
            param: {
                req: {}
            },
            callback: function (data) {
                if (data && data.greyType) {
                    callback(data.greyType);
                } else {
                    callback(0);
                }
            },
            onError: function () {
                callback(0);
            }
        });
    }


    function checkIsResellerRole(useableUserRoute) {
        var isResellerRole = false;
        if (useableUserRoute.length > 0 && useableUserRoute[0].channelRoleTypes && useableUserRoute[0].channelRoleTypes.length > 0) {
            useableUserRoute[0].channelRoleTypes.forEach(function (channelRole) {
                if (channelRole.roleID == 'ResellerRole') {
                    isResellerRole = true;
                }
            })
        }
        return isResellerRole;
    }

    function recordLoginInfo() {
        if (AUI.HDGWCall.getZoneId() == sysUrlCfg.oAuthConfig.chinaZoneID) {//国内的才打点 不能打错
            var recordLoginInfo = sysUrlCfg.esdk.codeserverDomain + "/PartnerCommunityService/v1/registerGuide/developer/recordLoginInfo";
            //1是PC端 2是移动端
            AUI.HDGWCall.callGWRest(recordLoginInfo, {
                loginType: AUI.BaseJSUtil.isMobileTerminal() ? '2' : '1',
                loginUrl: AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin")
            }, {type: "POST"});
        }
    }

    function setAccountLoginTime() {
        AUI.HDGWCall.callGW('OpenUP.Server4User.setAccountLoginTime', {req: {}});
    }

    function checkIsChildAccount(callback) {
        ajaxWithErrorHDGWCall.callGWOld("OpenUP.Server4User.getAgeGroupFlag", {
            param: {
                req: {}
            },
            callback: function (data) {
                ajaxWithErrorHDGWCall.callGWOld("OpenUP.Server4User.addNotRealName", {
                    param: {
                        req: {loginChannel:sysUrlCfg.user.loginChannel}
                    },
                    callback: function () {
                    },
                    onError: function () {
                    }
                });
                setTimeout(function () {
                    if (data && data.ageGroupFlag != 2) {//2是儿童
                        callback();
                    } else {
                        AUI.HDGWCall.logout(sysUrlCfg.user.indexUrl + "/instructionsforchildren/");
                    }
                }, 200)
            },
            onError: function () {
                callback();
            }
        });
    }

    var loginValidation = window.loginValidation = {
        validateAfterLogin: validateAfterLogin,
        getUserInfo: getUserInfo,
        isGreyDeveloper: isGreyDeveloper,
        queryClaimsInfo: queryClaimsInfo,
        handleGetUserInfo: handleGetUserInfo,
        checkIsResellerRole: checkIsResellerRole,
        recordLoginInfo: recordLoginInfo,
        setAccountLoginTime: setAccountLoginTime,
        checkIsChildAccount: checkIsChildAccount
    };
    if (typeof define === "function" && define.amd) {
        define('loginValidation',[], function () {
            return loginValidation;
        });
    }
})(window)
;
